export const pvzListTest = [
    {
        "id": 1,
        "name": "Пионерская ул, д. 50",
        "coords": [59.963539, 30.273171],
        "payment-on-delivery": true,
        "card-payment": true,
        "cash-payment": false,
        "route": "Метро, поворот налево, потом направо",
        "address": "Пункт выдачи заказов «DPD»",
        "time": "Пн-Вс: 09:00 - 21:00"
    },
    {
        "id": 2,
        "name": "Петергофское ш, д. 72, корп. 5",
        "coords": [59.845474, 30.116352],
        "payment-on-delivery": false,
        "card-payment": true,
        "cash-payment": false
    },
    {
        "id": 3,
        "name": "Пионерстроя ул, д. 8",
        "coords": [59.841428, 30.130977]
    },
    {
        "id": 4,
        "name": "Пискарёвский пр-кт, д. 25, стр. А",
        "coords": [59.969871, 30.413075]
    },
    {
        "id": 5,
        "name": "Пограничника Гарькавого ул, д. 6, корп. 1",
        "coords": [59.843096, 30.147712]
    },
    {
        "id": 6,
        "name": "Подвойского ул, д. 38",
        "coords": [59.917249, 30.490375]
    },
    {
        "id": 7,
        "name": "Подольская ул, д. 34",
        "coords": [59.914227, 30.326531]
    },
    {
        "id": 8,
        "name": "Просвещения пр-кт, д. 37",
        "coords": [60.047762, 30.355708]
    },
    {
        "id": 9,
        "name": "Просвещения пр-кт, д. 68, корп. 1",
        "coords": [60.044428, 30.378984]
    },
    {
        "id": 10,
        "name": "Просвещения пр-кт, д. 80, корп. 3, стр. А",
        "coords": [60.038506, 30.408044]
    },
    {
        "id": 11,
        "name": "Пулковская ул, д. 7",
        "coords": [59.839579, 30.348890]
    }
];

window.pvzListTest = pvzListTest;

